var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.3,
    height: 21.3,
    viewBox: "0 0 15.3 21.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a-user{stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.6 -2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a-user",
    d: "M15.375,3.75a3.75,3.75,0,1,1-3.75,3.75,3.75,3.75,0,0,1,3.75-3.75m0-1.5a5.25,5.25,0,1,0,5.25,5.25,5.25,5.25,0,0,0-5.25-5.25Z",
    transform: "translate(-1.125 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a-user",
    d: "M21.75,29.25h-1.5V25.5a3.75,3.75,0,0,0-3.75-3.75H12A3.75,3.75,0,0,0,8.25,25.5v3.75H6.75V25.5A5.25,5.25,0,0,1,12,20.25h4.5a5.25,5.25,0,0,1,5.25,5.25Z",
    transform: "translate(0 -6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ded898fe.svg";
export { ForwardRef as ReactComponent };